import { atom, useSetAtom } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';
import { useEffect } from 'react';

// These exist to restore buttons after the user clicks back. The browser restores state without re-executing code, so stale state is otherwise stuck

export const latestCreateConsultationCallAtom = atom<Date | null>();
export const latestMountAtom = atom<Date | null>();

export const isSubmittingConsultationAtom = atom((get) => {
    const latestMount = get(latestMountAtom);
    const latestCreate = get(latestCreateConsultationCallAtom);
    if (!latestCreate) return false;
    return latestCreate > latestMount;
});

export function useLatestMount() {
    useHydrateAtoms([[latestMountAtom, new Date()]]);
    const setLatestMount = useSetAtom(latestMountAtom);
    useEffect(() => {
        window.addEventListener('pageshow', onPageShow);
        return () => {
            window.removeEventListener('pageshow', onPageShow);
        };
        function onPageShow(event: PageTransitionEvent) {
            // If we care about fresh page vs back-forward, `event.persisted` is true when this is triggered for back-forward
            setLatestMount(new Date());
        }
    }, []);
}
